<script setup>
import {
  FieldDescription,
  FieldGroup,
  FieldSet,
} from '@/components/ui/field'

import UmisisModal from '../../../../../../../resources/js/components/umisis/generic/UmisisModal.vue'
import { onMounted, ref } from 'vue'
import InputText from '../../../../../../../resources/js/components/umisis/form/inputs/InputText.vue'
import { useModalControl } from '@/composables/modal/useUmisisModal.js'
import InputTagsWithPredefined from '../../../../../../../resources/js/components/umisis/form/inputs/InputTagsWithPredefined.vue'
import { useUserPermissionStore } from '../../stores/userPermissionStore.js'
import { useUserRoleStore } from '../../stores/userRoleStore.js'
import { toast } from 'vue-sonner'
const { componentRef: dialog, openModal, closeModal } = useModalControl()

defineExpose({
  openModal,
  closeModal
})

const props = defineProps({
  userRole: {
    type: Object,
    required: false,
    default:null,
  }
})

const roleName = ref('')
const rolePermissions = ref([])
// When the modal is opened, populate the fields with the userRole data
const onShow = () => {
  roleName.value = props.userRole?.name || ''
  rolePermissions.value = props.userRole?.permissions || []
  useUserPermissionStore().fetchItems({ not_paginated: true })
}


const loading = ref(false)
const validationErrors = ref(null)
const handleOk = async (bvEvent) => {
  bvEvent? bvEvent.preventDefault() : null
  const store = useUserRoleStore()
  if (props.userRole) {
    // we need to patch
    console.log('Patching user role:', props.userRole.id)
    try {
      validationErrors.value = null
      loading.value = true
      await store.itemPatch(props.userRole.id, {
        name: roleName.value,
        permissions_ids: rolePermissions.value.map(p => p.id)
      })
      loading.value = false
      closeModal()
    }
    catch (e) {
      console.error('Error updating user role:', e)
      loading.value = false
      if(e.response?.data?.errors) {
        validationErrors.value = e.response?.data?.errors
      }
      else if(e.response?.data?.message) {
        // use the notification system
        toast.error(e.response.data.message)
      }
    }

  }
  else {
    try {
      validationErrors.value = null
      loading.value = true
      await store.itemCreate({
        name: roleName.value,
        permissions_ids: rolePermissions.value.map(p => p.id)
      })
      loading.value = false
      closeModal()
    }
    catch (e) {
      console.error('Error updating user role:', e)
      loading.value = false
      if(e.response?.data?.errors) {
        validationErrors.value = e.response?.data?.errors
      }
      else if(e.response?.data?.message) {
        // use the notification system
        toast.error(e.response.data.message)
      }
    }
  }
}

</script>

<template>
  <UmisisModal ref="dialog" :ok-disabled="loading" :title="$t('userManager.actions.editRole')" @ok="handleOk" @show="onShow">
    <FieldSet>
      <FieldDescription>Specify what permissions compose this role.</FieldDescription>
      <FieldGroup>
        <InputText v-model="roleName" label="Role name" description="The name of the role" />
        <InputTagsWithPredefined v-model="rolePermissions" :options="useUserPermissionStore().items" label="Permissions" item-label="name" item-id="id" />
      </FieldGroup>
    </FieldSet>
  </UmisisModal>
</template>

<style scoped>

</style>
